import ListEquipmentFilter from "./ListEquipmentFilter";

export default ListEquipmentFilter;
